import {app} from "./config.ts";
import _ from "lodash";

export const token = (): string | null => _.isEmpty(app.auth) ? null : app.auth;

export const isLogin = (): boolean => !!token();

export const logout = (): void => {
  localStorage.removeItem("token");
};